import {createSlice} from "@reduxjs/toolkit";
import Session from "../../storage/local/Session";
import ApiRequest from "../../api/ApiRequest";

const slice = createSlice({
  name: 'user',
  initialState: {
    loaded: false,
    isGuest: true,
    profile: null,
  },
  reducers: {
    profileLoaded: (state, action) => {
      state.loaded = true;
      state.isGuest = null === action.payload;
      state.profile = action.payload;
    },
    signOut: (state) => {
      state.loaded = true;
      state.isGuest = true;
      state.profile = null;
      Session.removeTokens();
    },
  },
});

export const {profileLoaded, signOut} = slice.actions;

export const signIn = (tokens) => async (dispatch) => {
  Session.tokens = tokens;
  const data = await ApiRequest.me.getOne();
  if (!data) return;
  dispatch(profileLoaded(data));
};

export const reloadProfile = () => async (dispatch) => {
  const data = await ApiRequest.me.getOne();
  if (!data) return;
  dispatch(profileLoaded(data));
};

export const restoreSession = () => async (dispatch, getState) => {
  const state = getState();

  if (state.user.loaded || null !== state.user.profile) return;

  await Session.reloadTokens();

  if (null === Session.accessToken) {
    dispatch(profileLoaded(null));
    return;
  }

  const data = await ApiRequest.me.getOne();
  if (!data) return;
  dispatch(profileLoaded(data));
}

export default slice.reducer;
